import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormInput, FormButton, Margin, Text } from 'shared/components'

import * as styles from './styles'

const ResetFormComponent = ({ form, onSubmit }) => (
  <Form form={form} onSubmit={onSubmit} css={styles.form}>
    <Margin bottom={1}>
      <FormInput
        name="email"
        label="Email"
        type="email"
        placeholder="account@email.com"
        strictLong
      />
    </Margin>
    <Margin top={2} css={styles.buttonContainer}>
      <FormButton submit medium green css={styles.resetButton}>
        <Text size={16} upper bold black>
          Reset
        </Text>
      </FormButton>
    </Margin>
  </Form>
)

ResetFormComponent.propTypes = {
  form: PropTypes.shape(),
  onSubmit: PropTypes.func,
}

export default ResetFormComponent
